import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/criteria/form/styles.scss';export default {
  "form": "_form_1urcw_1",
  "buttons": "_buttons_1urcw_5"
};